export default "__VITE_ASSET__4HMOrQEY__"